import Breadcrumbs from '@/components/Breadcrumbs'
import SectionHeading from '@/components/ui/SectionHeading'
import Seo from '@/components/Seo'
import DisclaimerNote from '@/components/DisclaimerNote'
import { breadcrumbSchema } from '@/lib/schema'

function Disclaimer() {
  return (
    <>
      <Seo
        title="Financial Disclaimer"
        description="Mint Calculator's financial disclaimer: all calculator results are estimates for informational purposes only and do not constitute financial, investment, tax, or legal advice."
        path="/disclaimer"
        schema={breadcrumbSchema([{ name: 'Home', path: '/' }, { name: 'Financial Disclaimer', path: '/disclaimer' }])}
      />
      <div className="mx-auto max-w-3xl px-4 py-10 sm:px-6 lg:px-8">
        <Breadcrumbs items={[{ name: 'Home', path: '/' }, { name: 'Financial Disclaimer', path: '/disclaimer' }]} />
        <SectionHeading title="Financial Disclaimer" description="Please read carefully before relying on any calculator results." />

        <div className="mt-8">
          <DisclaimerNote />
        </div>

        <div className="mt-8 space-y-5 text-sm leading-relaxed text-slate-400">
          <p>
            Mint Calculator (www.mintcalculator.com) provides free calculators for budgeting, loan amortization,
            credit card and mortgage payoff, NFT/Web3 mint gas estimation, and numismatic coin valuation. All
            results produced by these tools are estimates generated from the inputs you provide and standard
            financial or metallurgical formulas. They are provided for general informational and educational
            purposes only.
          </p>
          <p>
            Nothing on this site constitutes financial, investment, tax, legal, or professional advice. Actual
            loan terms, budget outcomes, gas fees, and coin values may differ materially from our estimates due
            to market volatility, lender-specific terms, network congestion, dealer premiums, and other factors
            outside our control. Precious metal spot prices and gas prices fluctuate constantly and the figures
            you enter may not reflect real-time market conditions.
          </p>
          <p>
            You should independently verify any figures with a licensed financial advisor, accountant, lender,
            bullion dealer, or blockchain data provider before making financial decisions. Mint Calculator and
            its operators assume no liability for losses or damages resulting from reliance on any calculator
            output on this site.
          </p>
          <p>
            Some pages on this site contain affiliate links to third-party financial products (such as
            high-yield savings accounts, loan refinancing services, budgeting apps, and hardware wallets). We may
            earn a commission if you sign up through these links, at no additional cost to you. This does not
            influence the accuracy of our calculators or the objectivity of our content.
          </p>
        </div>
      </div>
    </>
  )
}

export default Disclaimer
